import customHeaders, { getSpace } from '../../common/headers';
import { FilterContainer } from '../../components/FilterContainer/FilterContainer';
import { useState, useEffect, useRef } from 'react';
import { Rating } from '@mui/material';
import { ReactComponent as StarIcon } from './img/rating_star.svg';
import { useParams, useLocation } from 'react-router-dom';
import {
    Tabs,
    DropDownSelector,
    RangeBox,
    TableBox,
    Checkbox,
    NoDataContent
} from '@lk-gtcom/ecomlab-components';
import useGeneralStore from '../../store/general';
import './AIAnalysis.scss';
import { TitlePage } from '../../components/TitlePage/TitlePage';
import { useDataTable } from '../../common/hooks';
import { TextPage } from '../../components/TextPage/TextPage';
import { MoonLoader } from 'react-spinners';
import { getValueMultiFilter } from '../../common/filtersFunc';
import { RequestController } from '../../common/filtersFunc';
import { ModalPaymentConfirmation } from '../../components/Modal/ModalPaymentConfirmation/ModalPaymentConfirmation';
import { periodWeek } from '../../common/constant';
import { msToLocalDate } from '../../common/constant'
import { options_prop_mp } from '../../common/globalVariables';
import { useURLSearchParams } from '../../common/useURLSearchParams';
import { fetchFilterV3 } from '../../common/filtersFunc';
import { useResponseHandler } from '../../common/auth';
import { useSavedFilters } from '../../common/useSavedFilters';

const btn_tab = [
    { label: 'Товары', value: 'product' },
    { label: 'По категориям', value: 'category' },
    { label: 'По брендам', value: 'brand' }
];

const optionRating = (rating) => {
    return (
        <div className="rating-option">
            <span className="text_span">{rating}</span>
            <Rating
                precision={1}
                defaultValue={rating}
                max={1}
                readOnly
                emptyIcon={<StarIcon style={{ opacity: '.1' }} />}
                icon={<StarIcon style={{ fill: '#faaf00' }} />}
                size="small"
            />
        </div>
    );
};

const ratingData = [
    { label: optionRating(1), value: 1 },
    { label: optionRating(2), value: 2 },
    { label: optionRating(3), value: 3 },
    { label: optionRating(4), value: 4 },
    { label: optionRating(5), value: 5 },
];

const AIAnalysis = ({ setQueryFeedbacks }) => {
    const selectedSpace = useGeneralStore((state) => state.selectedSpace);
    const headers = { ...customHeaders, ...getSpace(selectedSpace) };
    // Сохранённые фильтры: подставляются в URL при заходе, запись по кнопке
    const { isReady, saveFilters, clearSavedFilters, isSaved, hasSavedFilters } = useSavedFilters(selectedSpace?.value, 'AI-analysis');
    const { handleStatusCode, handleTableResponse, handleRequestError } = useResponseHandler();
    // Реф для хранения контроллера запросов
    const requestControllerRef = useRef(new RequestController());
    const location = useLocation();

    const [date, setDate] = useState(periodWeek());
    const [dateFrom, dateTo] = date;

    const [showTooltipStep1, setShowTooltipStep1] = useState(true);
    const [showTooltipStep2, setShowTooltipStep2] = useState(false);
    const [hideAlwaysTooltip, setHideAlwaysTooltip] = useState(false);

    const [pageValue, setPageValue] = useState(btn_tab[0]?.value)


    useEffect(() => {
        if (!hideAlwaysTooltip) {
            if (!showTooltipStep1 && !showTooltipStep2) {
                setShowTooltipStep2(true);
            }
        }
    }, [showTooltipStep1]);

    const activeTab = useParams()['*'];
    const [date_from, date_to] = date;

    const [isWithPhoto, setIsWithPhoto] = useState(false)
    const [isWithStocks, setIsWithStocks] = useState(false)

    // Фильтры
    const filterConfig = [
        { key: 'mp', type: 'multi' },
        { key: 'api', type: 'multi' },
        { key: 'category', type: 'multi' },
        { key: 'brand', type: 'multi' },
        { key: 'rating', type: 'multi' },
        { key: 'date_from', type: 'date' },
        { key: 'date_to', type: 'date' },
        { key: 'withPhoto', type: 'boolean' },
        { key: 'withStocks', type: 'boolean' },
    ];
    const { urlParams, updateURL, isInitialized, hasInitialParams } = useURLSearchParams(filterConfig);
    const [isFilterRequest, setIsFilterRequest] = useState(false);

    const [apiData, setApiData] = useState([]);
    const [categoryData, setCategoryData] = useState([]);
    const [brandData, setBrandData] = useState([]);

    const [selectedApi, setSelectedApi] = useState([{ label: 'Все', value: 'all' }]);
    const [selectedCategory, setSelectedCategory] = useState([{ label: 'Все', value: 'all' }]);
    const [selectedBrand, setSelectedBrand] = useState([{ label: 'Все', value: 'all' }]);
    const [selectedMarketplace, setSelectedMarketplace] = useState([{ label: 'Все', value: 'all' }]);
    const [selectedRating, setSelectedRating] = useState([{ label: 'Все', value: 'all' }]);

    const [apiPage, setApiPage] = useState(1);
    const [categoryPage, setCategoryPage] = useState(1);
    const [brandPage, setBrandPage] = useState(1);

    const [apiQuery, setApiQuery] = useState('');
    const [categoryQuery, setCategoryQuery] = useState('');
    const [brandQuery, setBrandQuery] = useState('');

    const [totalApi, setTotalApi] = useState(0);
    const [totalCategory, setTotalCategory] = useState(0);
    const [totalBrand, setTotalBrand] = useState(0)

    // Таблица
    const [isTableRequest, setIsTableRequest] = useState(false);
    const paginatorRef = useRef();
    const [setTable, tableProps, setTableFuncs] = useDataTable(
        paginatorRef.current?.setTotal,
        paginatorRef
    );
    const { setLoading, setFetchedData, setHeaders, setSort, setCustomHeaders } = setTableFuncs;

    // Инфо
    const [analysisData, setAnalysisData] = useState(null)
    const [loadingInfo, setLoadingInfo] = useState(false)

    // Modal
    const [isModalPaymentConfirmation, setIsModalPaymentConfirmation] = useState(false)
    const [statusPayment, setStatusPayment] = useState(false)
    const [answerData, setAnswerData] = useState(null)

    // Инициализация фильтров из URL параметров при первом рендере
    const [isInitialLoadFromURL, setIsInitialLoadFromURL] = useState(false);

    useEffect(() => {
        if (!isReady) return;
        if (!isInitialLoadFromURL) {
            setIsInitialLoadFromURL(true);

            // Обновляем все состояния фильтров
            setTimeout(() => {
                if (urlParams.mp) setSelectedMarketplace(urlParams.mp)
                if (urlParams.api) setSelectedApi(urlParams.api)
                if (urlParams.category) setSelectedCategory(urlParams.category)
                if (urlParams.brand) setSelectedBrand(urlParams.brand)
                if (urlParams.rating) setSelectedRating(urlParams.rating?.map(el => ({ label: el?.value == 'all' ? 'all' : optionRating(el?.value), value: el?.value })))
                if (urlParams.date_from) {
                    setDate([
                        new Date(parseInt(urlParams.date_from)),
                        new Date(parseInt(urlParams.date_to)),
                    ]);
                }
                // Checkbox
                if (urlParams.withPhoto) setIsWithPhoto(urlParams.withPhoto)
                if (urlParams.withStocks) setIsWithStocks(urlParams.withStocks)

                // Запускаем запрос таблицы и фильтров только при первой инициализации из URL
                setIsFilterRequest(prev => !prev);
                if (Object.keys(urlParams).length > 0) {
                    setIsTableRequest(prev => !prev);
                }
            }, 10);
        }
    }, [urlParams, isReady]);

    useEffect(() => {
        if (!isReady) return;
        updateURL({
            mp: urlParams?.mp || selectedMarketplace,
            api: urlParams?.api || selectedApi,
            category: urlParams?.category || selectedCategory,
            brand: urlParams?.brand || selectedBrand,
            rating: urlParams?.rating || selectedRating,
            date_from: urlParams?.date_from || dateFrom,
            date_to: urlParams?.date_to || dateTo,
        })
    }, [isReady]);


    useEffect(() => {
        setQueryFeedbacks(window?.location?.search)
    }, [window?.location?.search]);

    const resetTable = () => {
        paginatorRef.current?.reset();
        paginatorRef.current?.setTotal(0);
        // setFetchedData([])
        // setHeaders([])
        // setSort({})
    };

    // Таблица товаров для ИИ анализа
    const fetchTableData = (params, abortController = new AbortController()) => {
        let sort;
        let filtersParam = [];

        if (params) {
            [sort, filtersParam] = params;
        }

        // Устанавливаем loading в true только если запрос не прерван
        if (!abortController.signal.aborted) {
            setLoading(true);
        }

        let url = `https://apps0.ecomru.ru:4449/feedbacks-and-questions/ai-analytic-${pageValue}-table${sort?.length > 0
            ? '?order_param=' + sort[0] + '&order_param_direction=' + sort[1]
            : ''}`;

        const body = JSON.stringify({
            page: paginatorRef.current?.page,
            limit: paginatorRef.current?.limit,
            filters: filtersParam,
            mp_id_list: getValueMultiFilter(selectedMarketplace),
            category_id_list: getValueMultiFilter(selectedCategory),
            brand_id_list: getValueMultiFilter(selectedBrand),
            api_id_list: getValueMultiFilter(selectedApi),
            date_from: msToLocalDate(date_from),
            date_to: msToLocalDate(date_to),
            offer_id_list: ["all"],
            offer_id_name_search: "",
            with_photo: isWithPhoto,
            with_stocks: isWithStocks,
            product_valuation_list: getValueMultiFilter(selectedRating),
        });

        fetch(url, { body, method: 'POST', headers, signal: abortController.signal })
            .then(handleTableResponse)
            .then((json) => setTable(json))
            .catch(handleRequestError)
            .finally(() => {
                if (!abortController.signal.aborted) {
                    setLoading(false);
                    return
                }
            });
    };

    // Просмотр по категории, бренду, продукту
    const fetchAiInfo = (api_id, current_element, abortController = new AbortController()) => {
        let curr_path;
        if (pageValue === 'brand') curr_path = 'brands'
        if (pageValue === 'category') curr_path = 'categories'
        if (pageValue === 'product') curr_path = 'products'
        setLoadingInfo(true)

        let url = `https://apps1.ecomru.ru:4456/${curr_path}/reviews/summary/create?payment_confirmed=${statusPayment}`;

        const body = JSON.stringify({
            api_id,
            [`${pageValue === 'product' ? 'offer' : pageValue}_id`]: current_element,
            date_from: msToLocalDate(date_from),
            date_to: msToLocalDate(date_to),
        });

        fetch(url, { body, method: 'POST', headers, signal: abortController.signal })
            .then(async (res) => {
                if (res.ok) {
                    return res.json();
                } else {
                    if (res.status === 402) {
                        const errorData = await res.json()
                        setIsModalPaymentConfirmation(true)
                        setAnswerData(errorData?.detail)
                    }
                    const err = await res.json();
                    setAnalysisData(null)
                    throw new Error(JSON.stringify(err));
                }
            })
            .then((json) => {
                setAnalysisData(json)
            })
            .catch(handleRequestError)
            .finally(() => {
                setStatusPayment(false)
                if (abortController.signal.aborted) {
                    return;
                }
                setLoadingInfo(false)
            });
    };

    const onAction = (e) => {
        const api_id = e?.api_id
        const abortController = new AbortController();

        if (pageValue === 'category') {
            const category_id = e?.category_id
            fetchAiInfo(api_id, category_id)
        }
        if (pageValue === 'brand') {
            const brand_id = e?.brand_id
            fetchAiInfo(api_id, brand_id)
        }
        if (pageValue === 'product') {
            const brand_id = e?.['Товар']?.[4]
            fetchAiInfo(api_id, brand_id)
        }

        return () => abortController.abort();
    }

    useEffect(() => {
        if (!isReady) return;
        resetTable()
        setAnalysisData(null)

        const abortController = new AbortController();
        fetchTableData([], abortController);

        return () => {
            abortController.abort();
        }
    }, [pageValue, isWithPhoto, isWithStocks, date, isTableRequest]);

    const filtersApi = () => {
        const controller = requestControllerRef.current.createController('api');

        fetchFilterV3({
            selectedSpace: selectedSpace?.value,
            selectedMP: selectedMarketplace,
            page: apiPage,
            set: setApiData,
            searchParam: apiQuery,
            controller,
            setTotal: setTotalApi,
            dateFrom: date_from,
            dateTo: date_to,
            filter: 'fq_api_ids'
        })?.finally(() => {
            requestControllerRef.current.removeController('api');
        })
    };

    const filtersCategory = () => {
        const controller = requestControllerRef.current.createController('category');

        fetchFilterV3({
            selectedSpace: selectedSpace?.value,
            selectedMP: selectedMarketplace,
            selectedApi,
            page: categoryPage,
            set: setCategoryData,
            searchParam: categoryQuery,
            controller,
            setTotal: setTotalCategory,
            dateFrom: date_from,
            dateTo: date_to,
            filter: 'feedbacks_categories'
        })?.finally(() => {
            requestControllerRef.current.removeController('category');
        })
    };

    const filtersBrand = () => {
        const controller = requestControllerRef.current.createController('brand');

        fetchFilterV3({
            selectedSpace: selectedSpace?.value,
            selectedMP: selectedMarketplace,
            page: brandPage,
            selectedApi,
            selectedCategory,
            searchParam: brandQuery,
            set: setBrandData,
            controller,
            setTotal: setTotalBrand,
            dateFrom: date_from,
            dateTo: date_to,
            filter: 'feedbacks_brands'
        })?.finally(() => {
            requestControllerRef.current.removeController('brand');
        })
    };

    useEffect(() => {
        if (!isInitialLoadFromURL) return;
        filtersApi();
    }, [isFilterRequest, apiPage, apiQuery, pageValue]);

    useEffect(() => {
        if (!isInitialLoadFromURL) return;
        filtersCategory();
    }, [isFilterRequest, dateFrom, dateTo, categoryPage, categoryQuery, pageValue]);

    useEffect(() => {
        if (!isInitialLoadFromURL) return;
        filtersBrand();
    }, [isFilterRequest, dateFrom, dateTo, brandPage, brandQuery, pageValue]);

    useEffect(() => {
        return () => {
            // Отменяем все активные запросы фильтров
            requestControllerRef.current.abortAll();
        };
    }, []);

    useEffect(() => {
        setPageValue(activeTab);
    }, [activeTab]);

    return (
        <>
            {isModalPaymentConfirmation &&
                <ModalPaymentConfirmation
                    answerData={answerData}
                    setIsModal={setIsModalPaymentConfirmation}
                    setStatusPayment={setStatusPayment}
                />}

            <div className="ai-analysis">
                <TitlePage
                    title='Аналитика с помощью ИИ'
                />

                <div className="ai-analysis__filters">
                    <FilterContainer
                        loading={isSaved}
                        saveFilters={saveFilters}
                        clearSavedFilters={clearSavedFilters}
                        hasSavedFilters={hasSavedFilters}
                        onReset={(e) => {
                            setSelectedMarketplace([])
                            setSelectedApi([]);
                            setSelectedCategory([]);
                            setSelectedBrand([]);
                            setSelectedRating([])
                            updateURL({
                                mp: null,
                                api: null,
                                category: null,
                                brand: null,
                                rating: null
                            });
                            setIsTableRequest(!isTableRequest)
                            setIsFilterRequest(!isFilterRequest);
                        }}
                    >
                        <DropDownSelector
                            options_prop={options_prop_mp}
                            state={selectedMarketplace}
                            setState={setSelectedMarketplace}
                            placeholder="Маркетплейс"
                            total={options_prop_mp?.length}
                            multi
                            onBlur={() => {
                                updateURL({ mp: selectedMarketplace });
                                filtersApi();
                                filtersCategory();
                                filtersBrand();
                                setIsTableRequest(!isTableRequest)
                            }}
                        />

                        <DropDownSelector
                            options_prop={apiData}
                            state={selectedApi}
                            setState={setSelectedApi}
                            placeholder="Магазин"
                            total={totalApi}
                            fetchCallback={setApiPage}
                            setInputChange={setApiQuery}
                            multi
                            onBlur={() => {
                                updateURL({ api: selectedApi });
                                filtersCategory();
                                filtersBrand();
                                setIsTableRequest(!isTableRequest)
                            }}
                        />

                        <DropDownSelector
                            options_prop={categoryData}
                            state={selectedCategory}
                            setState={setSelectedCategory}
                            placeholder="Категория"
                            total={totalCategory}
                            fetchCallback={setCategoryPage}
                            setInputChange={setCategoryQuery}
                            multi
                            onBlur={() => {
                                updateURL({ category: selectedCategory });
                                filtersBrand();
                                setIsTableRequest(!isTableRequest)
                            }}
                        />

                        <DropDownSelector
                            options_prop={brandData}
                            state={selectedBrand}
                            setState={setSelectedBrand}
                            placeholder="Бренд"
                            total={totalBrand}
                            fetchCallback={setBrandPage}
                            setInputChange={setBrandQuery}
                            multi
                            onBlur={() => {
                                updateURL({ brand: selectedBrand });
                                setIsTableRequest(!isTableRequest)
                            }}
                        />

                        <DropDownSelector
                            options_prop={ratingData}
                            state={selectedRating}
                            setState={setSelectedRating}
                            placeholder="Оценка"
                            total={ratingData?.length}
                            multi
                            onBlur={() => {
                                updateURL({ rating: selectedRating.map((el) => ({ label: el.value, value: el.value })) });
                                setIsTableRequest(!isTableRequest)
                            }}
                        />

                        <Checkbox
                            value={isWithPhoto}
                            onChange={(e) => {
                                updateURL({ withPhoto: !isWithPhoto || null });
                                setIsWithPhoto(e)
                            }}
                        >
                            С фото
                        </Checkbox>

                        <Checkbox
                            value={isWithStocks}
                            onChange={(e) => {
                                updateURL({ withStocks: !isWithStocks || null });
                                setIsWithStocks(e)
                            }}
                        >
                            С остатком
                        </Checkbox>
                    </FilterContainer>

                    <RangeBox
                        date={date}
                        setDate={(e) => {
                            const [newDateFrom, newDateTo] = e;
                            updateURL({
                                date_from: newDateFrom,
                                date_to: newDateTo
                            });
                            setDate(e)
                        }} />
                </div>

                <Tabs
                    query={location?.search}
                    tabs={btn_tab}
                    pageValue={pageValue}
                />
                <div className="ai-analysis__content">
                    <TableBox
                        {...tableProps}
                        paginator={true}
                        ref={paginatorRef}
                        fetchCallback={fetchTableData}
                        onAction={onAction}
                    />

                    <div className="ai-analysis__data">
                        {loadingInfo ?
                            <div className='ai-analysis__loader'>
                                <MoonLoader />
                            </div>
                            :
                            (analysisData ?
                                <div className='ai-info'>

                                    <TitlePage
                                        medium
                                        title={<>Всего отзывов: <span style={{ color: 'blue', fontWeight: 700 }}>{analysisData?.total_reviews}</span></>}
                                    />

                                    <TitlePage
                                        medium
                                        title={<>Плюсы:</>}
                                        style={{ color: '#51ca64', fontWeight: 700 }}
                                    />

                                    {analysisData?.pros?.length
                                        ?
                                        analysisData?.pros?.map(({ topic, summary, review_count }) => {
                                            return <div className='ai-info__card'>
                                                <TextPage
                                                    style={{ color: '#51ca64', fontSize: '12px', fontWeight: 700 }}
                                                    text={topic || '-'}
                                                />

                                                <TextPage
                                                    style={{ color: 'grey', fontSize: '12px' }}
                                                    text={summary || '-'}
                                                />

                                                <TextPage
                                                    text={review_count}
                                                    style={{ fontWeight: 700 }}
                                                />
                                            </div>
                                        })
                                        :
                                        <TextPage
                                            text={'Нет данных'}
                                            style={{ color: 'grey', fontSize: '12px' }}
                                        />
                                    }

                                    <TitlePage
                                        medium
                                        title={<>Минусы:</>}
                                        style={{ color: '#F87171', fontWeight: 700 }}
                                    />

                                    {analysisData?.cons?.length
                                        ?
                                        analysisData?.cons?.map(({ topic, summary, review_count }) => {
                                            return <div className='ai-info__card' style={{ border: '2px solid #F87171' }}>
                                                <TextPage
                                                    style={{ color: '#F87171', fontSize: '12px', fontWeight: 700 }}
                                                    text={topic || '-'}
                                                />

                                                <TextPage
                                                    style={{ color: 'grey', fontSize: '12px' }}
                                                    text={summary || '-'}
                                                />

                                                <TextPage
                                                    text={review_count}
                                                    style={{ fontWeight: 700 }}
                                                />
                                            </div>
                                        })
                                        :
                                        <TextPage
                                            text={'Нет данных'}
                                            style={{ color: 'grey', fontSize: '12px' }}
                                        />
                                    }
                                </div>

                                : <NoDataContent
                                    title="Выберете товар из таблицы для анализа"
                                    border={false}
                                />)
                        }
                    </div>
                </div>
            </div>
        </>
    );
};

export { AIAnalysis };
